import React, { useEffect } from "react";
import { Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
// Components
import { PrivateRoute, HomeRouters } from "router";
import { AppLayout } from "layout";
import { Toast } from "components";
import { LockLoader } from "pages/lockLoader";
import { I18nProvider } from "locales";

import VerifyOtp from "pages/memberAuth/VerifyOtp";
import Login from "pages/memberAuth/Login";
import PublicRoute from "../router/PublicRoute";

export const DateFormetContext = React.createContext();

const App = () => {
  const { isRTL, lang } = useSelector((state) => state?.locales);

  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );

  useEffect(() => {
    localStorage.setItem("DonationLayout", false);
  }, []);

  const formatedDate = orgData?.dateFormat ? orgData?.dateFormat : "MM/DD/YYYY";

  return (
    <>
      <Helmet>
        <html lang={lang} dir={isRTL ? "rtl" : "ltr"} />
      </Helmet>
      <Router>
        <LockLoader />
        <Toast />
        <I18nProvider>
          <DateFormetContext.Provider value={formatedDate}>
            <AppLayout>
              <Switch>
                <PublicRoute path="/login" component={Login} />
                <PublicRoute path="/verify-otp/:id" component={VerifyOtp} />

                <PrivateRoute path="/">
                  <HomeRouters />
                </PrivateRoute>

                <Redirect path="*" to="/" />
              </Switch>
            </AppLayout>
          </DateFormetContext.Provider>
        </I18nProvider>
      </Router>
    </>
  );
};
export default App;
